import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { CheckSmallCircleFillIcon } from '@/icons';
import { type AchievementStandard } from '@/shared/features/ai-quiz-generation/types';
import { AddButton } from './AddButton';
import { CodeChip } from './CodeChip';
import { Placeholder } from './Placeholder';
export const StandardCodeRecommendation = ({
  selectedAchievementStandards,
  onAddStandards,
  onRemoveStandard,
  shouldButtonSimple
}: {
  selectedAchievementStandards: AchievementStandard[];
  onAddStandards: () => void;
  onRemoveStandard: (achievementStandard: AchievementStandard) => void;
  shouldButtonSimple: boolean;
}) => {
  const {
    t
  } = useTranslation(['build']);
  if (selectedAchievementStandards.length === 0) {
    return <Container>
        <Placeholder />
        <AddButton isSimple={shouldButtonSimple} onClick={onAddStandards} />
      </Container>;
  }
  return <Container data-sentry-element="Container" data-sentry-component="StandardCodeRecommendation" data-sentry-source-file="index.tsx">
      <div className="flex flex-row items-center gap-xs">
        <div className="flex shrink-0 flex-row items-center self-start pt-4xs">
          <CheckSmallCircleFillIcon size="2xs" fill={ICON_COLOR.strong} data-sentry-element="CheckSmallCircleFillIcon" data-sentry-source-file="index.tsx" />
          <span className="shrink-0 text-body-sm-bold text-violet-600">
            {t('build:build.standard.added.title')}
          </span>
        </div>
        <div className="flex flex-wrap gap-2xs">
          {selectedAchievementStandards.map(achievementStandard => <CodeChip key={achievementStandard.code} achievementStandard={achievementStandard} onRemove={() => onRemoveStandard(achievementStandard)} />)}
        </div>
      </div>
      <AddButton isSimple={true} onClick={onAddStandards} data-sentry-element="AddButton" data-sentry-source-file="index.tsx" />
    </Container>;
};
const Container = ({
  children
}: {
  children: React.ReactNode;
}) => {
  return <div className="mt-2xs flex flex-row items-center justify-between gap-xs rounded-sm bg-violet-50 p-md" data-sentry-component="Container" data-sentry-source-file="index.tsx">
      {children}
    </div>;
};